import { Box, Inline, Text } from 'braid-design-system';

import * as styles from './NudgePill.css';

interface NudgePillProps {
  label: string;
  count: number;
  isActive: boolean;
  id: string;
  isMobile: boolean;
  onClick: (id: string) => void;
}

export const NudgePill = ({
  label,
  count,
  isActive,
  id,
  isMobile,
  onClick,
}: NudgePillProps) => (
  <Box
    data-automation="displayPills"
    key={id}
    role="button"
    onClick={() => onClick(id)}
    className={`${styles.nudgePill} ${
      isActive ? styles.selectedNudgePill : styles.nudgePill
    }`}
    background={isActive ? 'customDark' : 'customLight'}
  >
    <Inline space="xxsmall" alignY="center" align="center">
      <Text size={isMobile ? 'small' : 'standard'}>{label}</Text>
      <Box
        display="inline"
        background="positiveLight"
        paddingY="xxsmall"
        paddingX="xsmall"
        borderRadius="large"
      >
        <Text tone="positive" size="xsmall" weight="medium">
          {count > 99 ? '99+' : count}
        </Text>
      </Box>
    </Inline>
  </Box>
);
